<!-- Buttons: delete, review -->
<div class="divflexend marginbottomminus12px padleft220px">
  <div class="maringright10px">
    <span class="font11px textalignright" *ngIf="ingredient">
      <span *ngIf="ingredient.id">
        <span class="colorgray">Created By:</span>
        {{ ingredient.createdBy }}&nbsp;&nbsp;&nbsp;
        {{
          ingredient.creationDate | date: "MM/dd/yyyy hh:mm:ss a"
        }}&nbsp;&nbsp;&nbsp; <span class="colorgray">Modified By:</span>
        {{ ingredient.modifiedBy }}&nbsp;&nbsp;&nbsp;
        {{ ingredient.lastModifiedDate | date: "MM/dd/yyyy hh:mm:ss a" }}
      </span>
    </span>
  </div>

  <div class="maringright10px">
    <button
      mat-icon-button
      [ngStyle]="{ color: 'orangered' }"
      (click)="copyProductIngredient()"
      matTooltip="Copy Ingredient Details {{
        prodIngredientIndex + 1
      }} to New Ingredient"
    >
      <mat-icon>file_copy</mat-icon>
    </button>
  </div>

  <div>
    <button
      mat-icon-button
      [ngStyle]="{ color: 'orangered' }"
      (click)="
        confirmDeleteProductIngredient(
          prodComponentIndex,
          prodLotIndex,
          prodIngredientIndex
        )
      "
      matTooltip="Delete Ingredient Details {{ prodIngredientIndex + 1 }}"
    >
      <mat-icon>delete_forever</mat-icon>
    </button>
  </div>
</div>

<!--
    &nbsp;&nbsp;
    <button mat-icon-button [ngStyle]="{'color':'orangered'}" (click)="confirmReviewIngredient()"
      matTooltip="Click to Confirm Ingredient Details {{prodIngredientIndex + 1}} data has been Reviewed">
      <mat-icon>check_circle</mat-icon>
    </button>
    <span *ngIf="ingredient.reviewDate" class="colorgray font12px">Reviewed
      By:{{ingredient.reviewedBy}}&nbsp;{{ingredient.reviewDate|date: 'MM/dd/yyyy hh:mm:ss a'}}
    </span>
  -->

<!-- Display Ingredient -->
<fieldset class="border">
  <legend class="border">
    Ingredient Details&nbsp;<b
      ><span class="colorgreen font17px">{{ prodIngredientIndex + 1 }}</span></b
    >
  </legend>

  <div class="divflexrow">
    <mat-form-field class="col-4-1">
      <mat-label>Applicant Ingredient Name</mat-label>
      <textarea
        matInput
        [(ngModel)]="ingredient.applicantIngredName"
        name="applicantIngredName"
        rows="2"
      >
      </textarea>
    </mat-form-field>

    <!-- Substance Selector for Substance/Ingredient Name -->
    <div class="col-4-1">
      <app-substance-selector
        (selectionUpdated)="ingredientNameUpdated($event)"
        eventCategory="substanceRelationshipRelatedSub"
        placeholder="Ingredient Name *"
        header="Ingredient Name *"
        [subuuid]="ingredientNameSubstanceUuid"
        [showMorelinks]="true"
      >
      </app-substance-selector>

      <!-- Display Active Moiety of Ingredient Name -->
      <div
        class="margintop10px"
        *ngFor="
          let active of ingredientNameActiveMoiety;
          let activeIndex = index
        "
      >
        <span class="font12px"
          ><b>{{ active }}</b></span
        >
        <span class="colorgray font11px">&nbsp;(Active Moiety)</span>
      </div>
    </div>

    <!-- Substance Selector for Basis of Strength Name -->
    <div class="col-4-1">
      <app-substance-selector
        (selectionUpdated)="basisOfStrengthUpdated($event)"
        eventCategory="substanceRelationshipRelatedSub"
        placeholder="Basis of Strength"
        header="Basis of Strength"
        [subuuid]="basisOfStrengthSubstanceUuid"
        [showMorelinks]="true"
      >
      </app-substance-selector>

      <!-- Display Active Moiety -->
      <div
        class="margintop10px"
        *ngFor="
          let active of basisOfStrengthActiveMoiety;
          let activeIndex = index
        "
      >
        <span class="font12px"
          ><b>{{ active }}</b></span
        >
        <span class="colorgray font11px">&nbsp;(Active Moiety)</span>
      </div>
    </div>

    <div class="col-4-1">
      <label>Ingredient Location</label><br />
      <span *ngFor="let data of locationList; let i = index">
        <mat-checkbox
          class="font11px"
          #checkBox
          [value]="data.value"
          [(ngModel)]="data.checked"
          name="data.value"
          (change)="setSelectedIngredientLocation(data, checkBox)"
        >
          {{ data.value }}
        </mat-checkbox>
        &nbsp;
      </span>

      <!-- Display Text Box if "Other" is selected from the textbox -->
      <div
        class="marginleft60p margintop20px"
        *ngIf="
          isIngredLocationOtherSelected && isIngredLocationOtherSelected == true
        "
      >
        <mat-form-field class="width120px">
          <mat-label>Other Ingredient Location</mat-label>
          <input
            matInput
            [(ngModel)]="ingredient.ingredientLocationText"
            name="ingredientLocationText"
          />
        </mat-form-field>
      </div>
    </div>
  </div>
  <!-- row-->

  <div class="form-row margintop20px">
    <app-cv-input
      class="col-4-1"
      domain="INGREDIENT_TYPE"
      title="Ingredient Type *"
      name="ingredientType"
      [model]="ingredient.ingredientType"
      (valueChange)="ingredient.ingredientType = $event"
    >
    </app-cv-input>

    <app-cv-input
      class="col-4-1"
      domain="PROD_INGREDIENT_FUNCTION"
      title="Ingredient Function"
      name="ingredientFunction"
      [model]="ingredient.ingredientFunction"
      (valueChange)="ingredient.ingredientFunction = $event"
    >
    </app-cv-input>

    <app-cv-input
      class="col-4-1"
      domain="PROD_GRADE"
      title="Grade"
      name="grade"
      [model]="ingredient.grade"
      (valueChange)="ingredient.grade = $event"
    >
    </app-cv-input>

    <app-cv-input
      class="col-4-1"
      domain="PROD_RELEASE_CHARACTERISTIC"
      title="Release Characteristics"
      name="releaseCharacteristic"
      [model]="ingredient.releaseCharacteristic"
      (valueChange)="ingredient.releaseCharacteristic = $event"
    >
    </app-cv-input>
  </div>

  <div class="form-row margintop10px">
    <mat-form-field class="col-4-1">
      <mat-label>Average</mat-label>
      <input
        matInput
        [(ngModel)]="ingredient.average"
        name="average"
      />
    </mat-form-field>

    <mat-form-field class="col-4-1">
      <mat-label>Low</mat-label>
      <input
        matInput
        [(ngModel)]="ingredient.low"
        name="low"
      />
    </mat-form-field>

    <mat-form-field class="col-4-1">
      <mat-label>High</mat-label>
      <input
        matInput
        [(ngModel)]="ingredient.high"
        name="high"
      />
    </mat-form-field>

    <app-cv-input
      class="col-4-1"
      domain="PROD_UNIT"
      title="Unit"
      name="unit"
      [model]="ingredient.unit"
      (valueChange)="ingredient.unit = $event"
    >
    </app-cv-input>
  </div>

  <div class="form-row margintop10px">
    <mat-form-field class="col-4-1">
      <mat-label>Original Numerator Number</mat-label>
      <input
        matInput
        [(ngModel)]="ingredient.originalNumeratorNumber"
        name="originalNumeratorNumber"
      />
    </mat-form-field>

    <app-cv-input
      class="col-4-1"
      domain="PROD_UNIT"
      title="Original Numerator Unit"
      name="originalNumeratorUnit"
      [model]="ingredient.originalNumeratorUnit"
      (valueChange)="ingredient.originalNumeratorUnit = $event"
    >
    </app-cv-input>

    <mat-form-field class="col-4-1">
      <mat-label>Original Denominator Number</mat-label>
      <input
        matInput
        [(ngModel)]="ingredient.originalDenominatorNumber"
        name="originalDenominatorNumber"
      />
    </mat-form-field>

    <app-cv-input
      class="col-4-1"
      domain="PROD_UNIT"
      title="Original Denominator Unit"
      name="originalDenominatorUnit"
      [model]="ingredient.originalDenominatorUnit"
      (valueChange)="ingredient.originalDenominatorUnit = $event"
    >
    </app-cv-input>
  </div>

  <div class="form-row">
    <mat-form-field class="col-4-1">
      <mat-label>Manufacturer</mat-label>
      <input
        matInput
        [(ngModel)]="ingredient.manufacturer"
        name="manufacturer"
      />
    </mat-form-field>

    <mat-form-field class="col-4-1">
      <mat-label>Manufacture Ingredient Catalog ID</mat-label>
      <input
        matInput
        [(ngModel)]="ingredient.manufactureIngredientCatalogId"
        name="manufactureIngredientCatalogId "
      />
    </mat-form-field>

    <mat-form-field class="col-4-2">
      <mat-label>Manufacture Ingredient URL</mat-label>
      <input
        matInput
        [(ngModel)]="ingredient.manufactureIngredientUrl"
        name="manufactureIngredientUrl "
      />
    </mat-form-field>
  </div>

  <div class="form-row">
    <mat-form-field class="col-4-1">
      <mat-label>Lot No</mat-label>
      <input
        matInput
        [(ngModel)]="ingredient.ingredLotNo"
        name="ingredLotNo"
      />
    </mat-form-field>

    <mat-form-field class="col-4-1">
      <mat-label>Confidentiality Code</mat-label>
      <input
        matInput
        [(ngModel)]="ingredient.confidentialityCode"
        name="confidentialityCode"
      />
    </mat-form-field>

    <mat-form-field class="col-4-2">
      <mat-label>Notes</mat-label>
      <input
        matInput
        [(ngModel)]="ingredient.notes"
        name="notes "
      />
    </mat-form-field>
  </div>
  <!-- row-->
</fieldset>
<br />
